export function ServiceContractStatusFactory() {
    return function ServiceContractStatus() {
        this.id = null;
        this.code = null;
        this.name = null;
    };
}
